import React from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router'
import HeaderContainer from 'containers/HeaderContainer'
import FooterContainer from 'containers/FooterContainer'
import ClientModalConductor from 'containers/ClientModalConductor'
import Grid from '@material-ui/core/Grid'
const MainLayout = ({ children, location }) => (
  <div>
    <ClientModalConductor />
    <HeaderContainer location={location} />
    <Grid
      spacing={0}
      className="page"
      container
      direction="row"
      alignItems="stretch"
      justify="space-between">
      {children}
    </Grid>
    <FooterContainer location={location} />
  </div>
)

MainLayout.propTypes = {
  children: PropTypes.node
}

export default withRouter(MainLayout)



// WEBPACK FOOTER //
// ./src/layouts/MainLayout/MainLayout.js